import { NgIf, TitleCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { PitchCardComponent } from '../pitch-card/pitch-card.component';

@Component({
  selector: 'app-pitchcard-folder-thumbnail',
  templateUrl: './pitchcard-folder-thumbnail.component.html',
  styleUrls: ['./pitchcard-folder-thumbnail.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PitchCardComponent, NgIf, TitleCasePipe],
  encapsulation: ViewEncapsulation.None
})
export class PitchCardFolderThumbnailComponent {
  private static nextGradientId = 0;
  private static readonly organizationJacketColor = '#24aeb5';

  @Input() scaleFactor = 0.5;
  @Input() pitchCardFolder: any;
  @Input() pocketColor: string = '#47B5B7';
  @Input() onlyFolder = false;
  @Input() folderLoader: number = null;

  @Output() openFolder = new EventEmitter<number>();
  @Output() addContent = new EventEmitter<number>();

  readonly backgroundGradientId = `folder-pocket-gradient-${PitchCardFolderThumbnailComponent.nextGradientId++}`;

  @HostBinding('style.--scale-factor') get scale() {
    return this.scaleFactor;
  }

  get jacketColor(): string {
    if (this.isOrganizationFolder || this.isBlackColor(this.pocketColor)) {
      return PitchCardFolderThumbnailComponent.organizationJacketColor;
    }

    return this.normalizeHexColor(this.pocketColor);
  }

  get jacketShadowColor(): string {
    const hexColor = this.jacketColor.slice(1);
    const channels = hexColor.match(/.{2}/g);

    if (!channels) {
      return this.jacketColor;
    }

    return `#${channels
      .map((channel) =>
        Math.round(parseInt(channel, 16) * 0.62)
          .toString(16)
          .padStart(2, '0')
      )
      .join('')}`;
  }

  get isOrganizationFolder(): boolean {
    const organizationId = this.pitchCardFolder?.organizationId;
    return (
      organizationId !== null &&
      organizationId !== undefined &&
      organizationId !== 0 &&
      organizationId !== '0' &&
      organizationId !== ''
    );
  }

  get isDefaultPocket(): boolean {
    return !!this.pitchCardFolder?.default;
  }

  get previewBusiness(): any {
    const content = this.pitchCardFolder?.content;

    if (!content) {
      return null;
    }

    if (Array.isArray(content)) {
      return content[0]?.business ?? null;
    }

    return Object.keys(content).length ? content : null;
  }

  handleOpenFolder() {
    this.openFolder.emit(this.pitchCardFolder.id);
  }

  handleAddContent() {
    this.addContent.emit(this.pitchCardFolder.id);
  }

  private isBlackColor(color: string): boolean {
    const value = color?.replace(/#/g, '').toLowerCase();
    return value === '000' || value === '000000';
  }

  private normalizeHexColor(color: string): string {
    const value = color?.replace(/#/g, '') || '47B5B7';

    if (/^[0-9a-f]{3}$/i.test(value)) {
      return `#${value
        .split('')
        .map((character) => character.repeat(2))
        .join('')}`;
    }

    return /^[0-9a-f]{6}$/i.test(value) ? `#${value}` : '#47B5B7';
  }
}
